module.exports = "<p>\r\n  logout works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = 190
// module chunks = 1